import React from 'react';
import { addQuery, QueryVal, removeQuery } from 'Helpers/Query';
import modalConsts from 'Consts/ModalNames';
import fr from 'facet-rest';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useHistory } from 'react-router-dom';
import { useRefreshActionItem } from 'Hooks/useRefreshEvent';
import { FDSecondaryActionButton } from '@facet-wealth/design';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import SimplePicker from 'Helpers/SimplePicker';
import { useDashboardContext } from 'Views/Dashboard/DashboardContext';
import Dialog from './Dialog';
import GroupedTasksDialog from './GroupedTasksDialog';

const TasksDialog = ({
  listCollection,
  refreshListCollection,
  dialogLabel,
}) => {
  const history = useHistory();
  const [showHidden, setShowHidden] = React.useState(QueryVal('showHidden') === true);
  const { displayErrorMessage } = useSnackbarContext();
  const [dialogOpen, setDialogOpen] = React.useState(QueryVal('modal') === modalConsts.actionItemList);
  const [dialogTaskCollection, setDialogTaskCollection] = React.useState(null);
  const { clientDashboardResource } = useDashboardContext();

  const replaceTaskResource = (resp) => {
    const [resource] = resp;
    dialogTaskCollection.resources().updateItem(resource);
    setDialogTaskCollection(dialogTaskCollection.copy());
  };

  // Sync params with showHidden state
  React.useEffect(() => {
    const searchParams = new URLSearchParams(history.location.search);

    if (showHidden) {
      searchParams.set('showHidden', 'true');
    } else {
      searchParams.delete('showHidden');
    }

    history.replace({ search: searchParams.toString() });
  }, [showHidden]);

  const getTaskCollection = async (isHidden) => {
    setShowHidden(isHidden);
    const queryName = isHidden ? fr.queries.householdHiddenTasks.name : fr.queries.householdActiveTasks.name;

    try {
      const resp = await listCollection.query(queryName, (link) => {
        return link.get();
      }, () => {
        return null;
      });
      setDialogTaskCollection(resp);
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  };

  const refreshTaskCollection = async () => {
    return getTaskCollection(showHidden);
  };

  useRefreshActionItem(() => {
    return refreshTaskCollection();
  }, [refreshTaskCollection]);

  const handleClose = () => {
    setDialogOpen(false);
    removeQuery('modal');
    refreshListCollection();
  };

  return (
    <>
      <Box paddingTop={2}>
        <FDSecondaryActionButton
          onClick={() => {
            addQuery({ [modalConsts.modal]: modalConsts.actionItemList });
            setDialogOpen(true);
            return refreshTaskCollection();
          }}
          size="sm"
          test={'action-item-view-all'}
          label={dialogLabel || 'View All'}
        />
      </Box>
      <SimplePicker
        resource={clientDashboardResource}
        relationship={fr.relationships.groupedTasks.name}
        hasRelationship={({ relationship }) => (
          <GroupedTasksDialog
            open={dialogOpen}
            handleClose={handleClose}
            relationship={relationship}
            showHidden={showHidden}
            setShowHidden={setShowHidden}
          />
        )}
        noRelationship={() => (
          <Dialog
            open={dialogOpen}
            showHidden={showHidden}
            handleClose={handleClose}
            taskCollection={dialogTaskCollection}
            getTaskCollection={getTaskCollection}
            replaceTaskResource={replaceTaskResource}
            refreshDialogTaskCollection={refreshTaskCollection}
          />
        )}
      />
    </>
  );
};

export default TasksDialog;
